import type { KeyboardEvent } from "react";

/**
 * Opens a Headless UI listbox on Enter. Its button submits the surrounding form on Enter instead,
 * like a native `<select>`, which leaves a color picker opening on Space only.
 */
export function openListboxOnEnter(event: KeyboardEvent<HTMLButtonElement>) {
  if (event.key !== "Enter") return;
  // Headless UI skips its own handler for an event a passed-in handler prevented

  // TODO: consider migrating to Base UI (Select) to avoid this workaround
  event.preventDefault();
  event.currentTarget.click();
}
